export const panoramaViewConfig = [
  {
    id: "panorama1",
  },
];
